var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2786 4.18526H11.1998V2.99738C11.1998 2.48829 10.7876 2.07617 10.2786 2.07617H5.64825C5.13916 2.07617 4.72704 2.48829 4.72704 2.99738V4.18526H1.72098C0.896733 4.18526 0.242188 4.86405 0.242188 5.66405V6.51254L7.12704 9.71254C7.17552 9.25193 7.53916 8.88829 7.99976 8.88829C8.46037 8.88829 8.84825 9.25193 8.87249 9.71254L15.7573 6.51254V5.66405C15.7573 4.86405 15.1028 4.18526 14.2786 4.18526ZM10.7149 4.18526H5.21188V2.99738C5.21188 2.75496 5.40582 2.56102 5.64825 2.56102H10.2786C10.521 2.56102 10.7149 2.75496 10.7149 2.99738V4.18526Z",
    fill: "#4785FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.41165 10.8276V9.78517C8.41165 9.56699 8.24195 9.37305 7.99952 9.37305C7.7571 9.37305 7.5874 9.54274 7.5874 9.78517V10.8276C7.5874 11.0458 7.7571 11.2397 7.99952 11.2397C8.24195 11.2397 8.41165 11.0458 8.41165 10.8276Z",
    fill: "#4785FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.89673 10.8267C8.89673 11.3116 8.50885 11.7237 7.99976 11.7237C7.49067 11.7237 7.10279 11.3358 7.10279 10.8267V10.2449L0.242188 7.04492V13.4449C0.242188 14.2692 0.896733 14.9237 1.72098 14.9237H14.2786C15.1028 14.9237 15.7573 14.2692 15.7573 13.4449V7.04492L8.89673 10.2449V10.8267Z",
    fill: "#4785FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.66546aef7f19f65f26502d602e4626fa.svg";
export { ForwardRef as ReactComponent };